export const fetchTipoDocumentoAction = () => ({ type: 'FETCH_TIPO_DOCUMENTO' });
export const fetchTipoDocumentoActionSuccess = data => ({ type: 'FETCH_TIPO_DOCUMENTO_SUCCESS', data });
export const fetchTipoDocumentoActionError = error => ({ type: 'FETCH_TIPO_DOCUMENTO_ERROR', error });
